import { render, staticRenderFns } from "./DesktopView.vue?vue&type=template&id=1e202f52&scoped=true&"
import script from "./DesktopView.vue?vue&type=script&lang=js&"
export * from "./DesktopView.vue?vue&type=script&lang=js&"
import style0 from "./DesktopView.vue?vue&type=style&index=0&id=1e202f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e202f52",
  null
  
)

export default component.exports